<template>
  <div class="tva-parallax" ref="container">
    <div class="tva-shadows"></div>
    <div
      class="tva-image"
      :style="{
  transform: `translateY(-${offset}px)`,
  backgroundImage: `url(${image})`,
  height: `${imageHeight}%`,
  backgroundPosition: `${imagePosition}`,
  transition: `transform ${ease} ease-out`}"
      ref="image"
    ></div>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  props: {
    image: {
      type: String
    },
    imagePosition: {
      type: String,
      default: "50% 50%"
    },
    speed: {
      type: Number,
      default: 1.5
    },
    ease: {
      type: String,
      default: "0.5s"
    }
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("scroll", () => {
        this.scroll();
      });
    });
  },
  computed: {
    imageHeight() {
      return 100 * this.speed;
    }
  },
  watch: {
    scrollY(scrollY) {
      let position = this.$refs.container.getBoundingClientRect().top;
      let containerHeight = this.$refs.container.getBoundingClientRect().height;
      let imageHeight = this.$refs.image.getBoundingClientRect().height;

      if (position < scrollY && position + containerHeight > 0) {
        // Container is in viewport

        let scale = d3.scaleLinear()
          .domain([window.innerHeight + containerHeight, 0])
          .range([0, imageHeight - containerHeight]);

        this.offset = (position + containerHeight)* 0.1;
      }
    }
  },
  methods: {
    scroll() {
      if (this.scrollY !== window.pageYOffset) {
        this.scrollY = window.pageYOffset;
      }
    }
  },
  data() {
    return {
      offset: 0,
      scrollY: 0
    };
  }
};
</script>

<style lang="scss" scoped>
.tva-parallax {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.tva-shadows {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1) 0%,
    rgba(0, 0, 0, 0) 5%,
    rgba(0, 0, 0, 0) 95%,
    rgba(0, 0, 0, 0.1) 100%
  );
}

.tva-image {
  background-size: cover;
  background-repeat: no-repeat;
}
</style>